enum ThemeFontWeights {
  Bold = 'bold',
  Medium = 'medium',
  Normal = 'normal',
}

export default ThemeFontWeights;
